import {
    get_delivery_contact_details,
} from "./delivery_helpers";
import { delivery_address_methods } from "./delivery_address_methods";

export default {
    name: "Delivery",
    data: () => ({
        delivery_address_form: {
            address_id: null,
            contact_name: "",
            email: "",
            contact_phone: "",
            street_address: "",
            suburb: "",
            city: "",
            province: "",
            postal_code: "",
        },
        saved_user_addresses: [],
        saved_addresses_loading: false,
        saved_address_saving: false,
        deleting_address_id: null,
        selected_saved_address_id: null,
    }),

    mounted() {
        if (this.is_checkout && this.active_delivery_type === "delivery") {
            this.prepare_delivery_address_form();
            this.fetch_user_addresses();
        }
    },

    props: {
        delivery_type: {
            type: String,
            required: false,
            default: ""
        },
        deliveryType: {
            type: String,
            required: false,
            default: null
        },
        user_details: {
            type: Object,
            required: false,
            default: null
        },
        userDetails: {
            type: Object,
            required: false,
            default: null
        },
        delivery_address: {
            type: Object,
            required: false,
            default: () => ({})
        },
        deliveryAddress: {
            type: Object,
            required: false,
            default: () => ({})
        },
        show_saved_addresses: {
            type: Boolean,
            required: false,
            default: true
        },
        showSavedAddresses: {
            type: Boolean,
            required: false,
            default: null
        },
        validation_errors: {
            type: Object,
            required: false,
            default: () => ({})
        },

    },

    watch: {
        active_user_details() {
            if (this.is_checkout && this.active_delivery_type === "delivery") {
                this.sync_delivery_address_form({ include_user_fallback: true });
                this.emit_delivery_address();
                this.fetch_user_addresses();
            }
        },
        active_delivery_type(type) {
            if (this.is_checkout && type === "delivery") {
                this.prepare_delivery_address_form();
                this.fetch_user_addresses();
            }
        },
        active_delivery_address: {
            deep: true,
            handler() {
                if (this.is_checkout && this.active_delivery_type === "delivery") {
                    this.sync_delivery_address_form();
                }
            }
        },
    },

    computed: {
        is_checkout() {
            return this.$route.path.includes("/cart_checkout");
        },
        active_delivery_type() {
            return this.deliveryType || this.delivery_type || "";
        },
        active_user_details() {
            return this.userDetails || this.user_details || {};
        },
        active_delivery_address() {
            return this.deliveryAddress || this.delivery_address || {};
        },
        can_show_saved_addresses() {
            return this.showSavedAddresses !== null ? this.showSavedAddresses : this.show_saved_addresses;
        },
        active_validation_errors() {
            const errors = this.validation_errors || {};
            return errors && typeof errors === "object" ? errors : {};
        }
    },

    methods: {
        ...delivery_address_methods,

        prepare_delivery_address_form() {
            this.sync_delivery_address_form({ include_user_fallback: true });
            this.emit_delivery_address();
        },

        sync_delivery_address_form({ include_user_fallback = false } = {}) {
            this.delivery_address_form = {
                ...this.delivery_address_form,
                ...this.normalize_user_address(this.active_delivery_address, include_user_fallback),
            };

            if (include_user_fallback) {
                this.prefill_delivery_contact_details();
            }
        },
        prefill_delivery_contact_details() {
            const contact_details = get_delivery_contact_details(
                this.active_user_details,
                this.active_delivery_address
            );

            if (!this.delivery_address_form.contact_name) {
                this.delivery_address_form.contact_name = contact_details.contact_name;
            }

            if (!this.delivery_address_form.email) {
                this.delivery_address_form.email = contact_details.email;
            }

            if (!this.delivery_address_form.contact_phone) {
                this.delivery_address_form.contact_phone = contact_details.contact_phone;
            }
        },
    }
};
